import { Routes, Route, Navigate } from 'react-router-dom';
import { routes } from './routes';
import { Layout } from '@shared/components';

export const AppRouter = () => {
  return (
    <Layout>
      <Routes>
        {routes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
};

